'use client';

import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';

const styles = {
  closeButton: 'absolute left-0 z-11',
  closeIcon: 'w-6 h-6',
};

type THeaderCloseProps = {
  onClick?(): void;
  href?: string;
};

export const HeaderClose: FC<THeaderCloseProps> = ({ onClick, href }) => {
  if (href) {
    return (
      <Link href={href} className={styles.closeButton}>
        <Image
          width={24}
          height={24}
          src="/icons/close.svg"
          alt="Перейти"
          className={styles.closeIcon}
        />
      </Link>
    );
  }

  return (
    <button className={styles.closeButton} onClick={onClick}>
      <Image
        width={24}
        height={24}
        src="/icons/close.svg"
        alt="banner"
        className={styles.closeIcon}
      />
    </button>
  );
};
